import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'

import { useNavigate } from 'react-router'

import { Card } from '@sainsburys-tech/luna-react'
import Loading from '../components/Loading'
import useStoresListLoader from '../hooks/useStoreListLoader'
import useSearchStoresListLoader from '../hooks/useSearchStoresListLoader'
import StoreSearch from '../components/StorePage/StoreSearch'
import StoreList from '../components/StorePage/StoreList'
import resetData from '../utils/resetData'

const StorePage = () => {
  const navigateTo = useNavigate()
  const context = useContext(AppContext)

  const [searchQuery, setSearchQuery] = useState({ query: '', code: '' })
  const [storesListResource, loadStores] = useStoresListLoader()

  const [searchStoresListResource, loadSearchStores] =
    useSearchStoresListLoader()

  const setSearchStoreList = (code: string, query: string) => {
    if (query !== '' || code !== '') {
      loadSearchStores.current(code, query)
      if (context && searchStoresListResource.isReady) {
        context.storeList = searchStoresListResource.data
      }
    }
  }

  useEffect(() => {
    loadStores.current()
  }, [loadStores])

  useEffect(() => {
    setSearchStoreList(searchQuery.code, searchQuery.query)
  }, [searchQuery.query, searchQuery.code])

  const changeCurrentStore = (storeSelected: any) => {
    const newStore = {
      storeCode: storeSelected.Id ?? '',
      legacyStoreCode: storeSelected.code ?? storeSelected.argos_code ?? storeSelected.myhr_code ?? '',
      storeName: storeSelected.name,
      inScope: storeSelected ? true : false
    }
    if (context && newStore) {
      context.store = newStore
      resetData(context)
      navigateTo('/')
    }
  }

  const searchStores = (code: string, query: string) => {
    setSearchQuery({ code: code, query: query })
    setSearchStoreList(code, query)
  }

  if (searchQuery.code === '' && searchQuery.query === '') {
    if (context && storesListResource.data) {
      context.storeList = storesListResource.data
    }
  } else {
    if (
      context &&
      searchStoresListResource.isReady &&
      !storesListResource.hasError
    ) {
      context.storeList = searchStoresListResource.data
    }
  }

  if (
    searchQuery.code === '' &&
    searchQuery.query === '' &&
    !storesListResource.hasLoaded &&
    !storesListResource.hasError
  )
    return <Loading message={'Loading Stores'} />

  return (
    <div className="s-store-page s-store-mobile">
      <Card padded="true" id="s-store-search-page-card" className="s-page-card">
        <StoreSearch searchStores={searchStores} />
        <StoreList
          selectStore={changeCurrentStore}
          queryCode={searchQuery.code}
        />
      </Card>
    </div>
  )
}

export default StorePage
